import { useContext, useEffect } from 'react';
import { Context } from 'app/index';
import { MenuTypes } from 'app/components/navbar/Navbar';

export function useToggleCompactMenu() {
    const {
        settings: {
            navbar: { settings },
        },
    } = useContext(Context);
    useEffect(() => {
        if (settings.type === MenuTypes.compact) {
            document.documentElement.style.setProperty(
                `scroll-padding`,
                `var(--nav)`
            );
        } else {
            document.documentElement.style.setProperty(`scroll-padding`, `0px`);
        }
    }, [settings.type]);
}
